module.exports = __webpack_public_path__ + "static/img/bgJoinUs.8176423.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bgJoinUs.jpg
// module id = zngW
// module chunks = 13